// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";
import "../ShadersWGSL/ShadersInclude/atmosphereUboDeclaration";
import "core/ShadersWGSL/ShadersInclude/helperFunctions";
import "../ShadersWGSL/ShadersInclude/atmosphereFunctions";

const name = "skyViewPixelShader";
const shader = `#define RENDER_SKY_VIEW
#include<atmosphereUboDeclaration>
var transmittanceLutSampler: sampler;var transmittanceLut: texture_2d<f32>;var multiScatteringLutSampler: sampler;var multiScatteringLut: texture_2d<f32>;
#include<helperFunctions>
#include<atmosphereFunctions>
varying vUV: vec2f;@fragment
fn main(input: FragmentInputs)->FragmentOutputs {fragmentOutputs.color=renderSkyView(input.vUV,transmittanceLut,multiScatteringLut);}
`;
// Sideeffect
if (!ShaderStore.ShadersStoreWGSL[name]) {
    ShaderStore.ShadersStoreWGSL[name] = shader;
}
/** @internal */
export const skyViewPixelShaderWGSL = { name, shader };
